import { Link } from "@tanstack/react-router";
import { X, Instagram, Linkedin, Youtube, Mail, MapPin, Phone } from "lucide-react";
import logo from "@/assets/prico_logo_horizontal.png.asset.json";

export function Footer() {
  const socialUrls = [
    {
      'icon': X,
      'url': 'https://x.com/mediabroscom'
    }, // X,
    {
      'icon': Linkedin,
      'url': 'https://www.linkedin.com/company/mediabros/'
    }, // Linkedin,
    {
      'icon': Youtube,
      'url': 'https://www.youtube.com/@mediabros8187/videos'
    }, // Youtube,
  ];
  return (
    <footer className="mt-32 border-t border-border bg-[var(--cream)]">
      <div className="container-prico py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2 space-y-4">
          <img src={logo.url} alt="PRICO" className="h-9 w-auto rounded-sm shadow-sm" />
          <p className="text-sm text-muted-foreground max-w-sm">
            Compara precios, ahorra inteligente. PRICO es la red social del mejor precio para
            tu mercado, medicinas y compras diarias.
          </p>
          <div className="flex gap-2">
            {socialUrls.map((socialItem, i) => (
              <a
                key={i}
                href={socialItem.url}
                aria-label="Social"
                className="size-10 rounded-full grid place-items-center border border-border bg-card hover:bg-primary hover:text-primary-foreground hover:border-primary transition"
              >
                <socialItem.icon className="size-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="space-y-3">
          <h4 className="text-sm font-bold uppercase tracking-wider">Explorar</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/nosotros" className="hover:text-primary">Nosotros</Link></li>
            <li><Link to="/productos" className="hover:text-primary">Productos</Link></li>
            <li><Link to="/blog" className="hover:text-primary">Blog</Link></li>
            <li><Link to="/contacto" className="hover:text-primary">Contacto</Link></li>
          </ul>
        </div>

        <div className="space-y-3">
          <h4 className="text-sm font-bold uppercase tracking-wider">Contacto</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex items-start gap-2"><Phone className="size-4 mt-0.5 text-primary" /> +57 316-320-1208 </li>
            <li className="flex items-start gap-2"><Mail className="size-4 mt-0.5 text-primary" /> support@pricoapp.com</li>
            <li className="flex items-start gap-2"><MapPin className="size-4 mt-0.5 text-primary" /> Medellín, Colombia</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-prico py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} PRICO. Todos los derechos reservados.</p>
          <div className="flex flex-wrap gap-4">
            <Link to="/legal" className="hover:text-primary">Aviso Legal y Privacidad</Link>
            <Link to="/cookies" className="hover:text-primary">Política de Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
